import { Box, Button, CircularProgress, makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import { FC, useState } from 'react'
import { useApi } from 'service/useApi'
import { useI18n } from 'utils/localisation'
import { logError } from 'utils/logger'

const useStyles = makeStyles<Theme>((theme) => ({
  emailResent: {
    color: theme.palette.success.main,
  },
}))

type LoginActivationErrorProps = {
  email: string
}

export const LoginActivationError: FC<LoginActivationErrorProps> = ({ email }) => {
  const classes = useStyles()
  const { translate } = useI18n()
  const { customers: customersApi } = useApi()

  const [emailResent, setEmailResent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const sendActivationEmail = async () => {
    setIsLoading(true)

    try {
      await customersApi.sendActivationEmail(email)
      setEmailResent(true)
    } catch (error) {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      logError(error)
    } finally {
      setIsLoading(false)
    }
  }

  if (emailResent) {
    return (
      <Typography variant="body1" className={classes.emailResent}>
        {translate('login-activation-error-success')}
      </Typography>
    )
  }

  return (
    <>
      <Typography variant="body1" color="error">
        {translate('login-activation-error-title')}
      </Typography>
      <Box display="flex" alignItems="center">
        <Typography variant="body1">{translate('login-activation-error-not_received')}</Typography>
        {isLoading ? (
          <Box ml={2}>
            <CircularProgress size={30} thickness={7} />
          </Box>
        ) : (
          <Button onClick={sendActivationEmail}>{translate('login-activation-error-resend')}</Button>
        )}
      </Box>
    </>
  )
}
